import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FuncionalidadControl } from '../../../_models/funcionalidad-control';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaService } from '../../../_services/lista.service';
import { FlujoVentaPasoReintentoService } from '../../../_services/flujo-venta-paso-reintento.service';
import { FlujoVentaPasoReintentoFuncionalidadControlService } from '../../../_services/flujo-venta-paso-reintento-funcionalidad-control.service';
import { NavService } from '../../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { FlujoVentaPaso } from '../../../_models/flujo-venta-paso';
import { EstadoCausalService } from '../../../_services/estado-causal.service';
import { FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitudService } from '../../../_services/flujo-venta-paso-reintento-funcionalidad-control-causal-solicitud.service';
import { FlujoVentaPasoReintentoCausalSolicitudService } from '../../../_services/flujo-venta-paso-reintento-causal-solicitud.service';

@Component( {
  selector: 'app-flujo-venta-reintento',
  templateUrl: 'flujo-venta-reintento.component.html'
} )

export class FlujoVentaReintentoComponent implements OnInit {

  @Input() lisControlesTodos: FuncionalidadControl[] = [];
  @Input() tipo: string;
  @Input() fluVentaPaso: FlujoVentaPaso;
  @Input() lisEstados: SelectItem[] = [];
  @Input() verRegresar = false;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();
  formulario: FormGroup;
  submitted = false;
  cargando = true;
  lisItemTodos: SelectItem[] = [];
  lisControles: SelectItem[] = [];
  listado: any[] = [];
  regSeleccionado: any;
  keys = {
    AUTH: {
      id: 'idFlujoVentaPasoReintento',
      idControl: 'idModoAutenticacion',
      control: 'modoAutenticacion',
      servicio: 'fluVentaReintentoService',
      servicioCausal: 'fluVentaPasoReintentoCausalService',
      idCausal: 'idFlujoVPReintentoCausalSolicitud'
    },
    FUNCON: {
      id: 'idFlujoVPReintentoFuncionalidadControl',
      idControl: 'idFuncionalidadControl',
      control: 'funcionalidadControl',
      servicio: 'fluVentaReintentoFuncionalidadControlService',
      servicioCausal: 'fluVentaPasoReintentoFuncionalidadControlCausalService',
      idCausal: 'idFlujoVPReintentoFCCausalSolicitud'
    }
  };
  columnas: any[] = [];
  lisCausales: SelectItem[] = [];
  carEstados = false;

  constructor( private lisService: ListaService,
               private fluVentaReintentoService: FlujoVentaPasoReintentoService,
               private fluVentaReintentoFuncionalidadControlService: FlujoVentaPasoReintentoFuncionalidadControlService,
               private navService: NavService,
               private fb: FormBuilder,
               private estCausalService: EstadoCausalService,
               private fluVentaPasoReintentoFuncionalidadControlCausalService: FlujoVentaPasoReintentoFuncionalidadControlCausalSolicitudService,
               private fluVentaPasoReintentoCausalService: FlujoVentaPasoReintentoCausalSolicitudService,
               private conService: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'control', header: this.navService.buscarMensaje( 'FLUJOVENTAREINTENTO.LBL_CONTROL' ), sort: false },
      { field: 'cantidadReintentos', header: this.navService.buscarMensaje( 'FLUJOVENTAREINTENTO.LBL_CANTIDADREINTENTOS' ), sort: false },
      { field: 'estado', header: this.navService.buscarMensaje( 'FLUJOVENTAREINTENTO.LBL_ESTADO' ), sort: false },
      { field: 'causal', header: this.navService.buscarMensaje( 'FLUJOVENTAREINTENTO.LBL_CAUSAL' ), sort: false },
      {
        field: 'indicadorMostrarObservacion',
        header: this.navService.buscarMensaje( 'FLUJOVENTAREINTENTO.LBL_REQUIERERECOMENTARIO' ),
        sort: false
      },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    if ( this.tipo === 'AUTH' ) {
      forkJoin( this.lisService.getMasterDetails( 'ListasModosAutenticaciones' ),
        this.fluVentaReintentoService.listadoPorIdFlujoVentaPaso( this.fluVentaPaso.idFlujoVentaPaso ),
        this.fluVentaPasoReintentoCausalService.listadoPorFlujoVenta( this.fluVentaPaso.idFlujoVentaPaso ) ).subscribe( ( [ lisAutenticacion, lisFlujoIntento, lisCausales ] ) => {
        this.lisItemTodos = lisAutenticacion.map( e => ( { label: e.nombre, value: e.idLista } ) );
        this.cargarListado( lisFlujoIntento, lisCausales );
        this.cargarItems();
        this.cargarFormulario();
        this.cargando = false;
      } );
    } else {
      forkJoin( this.fluVentaReintentoFuncionalidadControlService.listadoPorIdFlujoVentaPaso( this.fluVentaPaso.idFlujoVentaPaso ),
        this.fluVentaPasoReintentoFuncionalidadControlCausalService.listadoPorFlujoVenta( this.fluVentaPaso.idFlujoVentaPaso ) ).subscribe( ( [ listado, lisCausales ] ) => {
        this.cargarListado( listado, lisCausales );
        this.lisItemTodos = this.lisControlesTodos.map( e => ( { label: e.nombre, value: e.idFuncionalidadControl } ) );
        this.cargarItems();
        this.cargarFormulario();
        this.cargando = false;
      } );
    }
  }

  cargarListado( listado: any[], lisCausales: any[] ) {
    this.listado = [];
    listado.forEach( e => {
      this.listado.push( this.crearItem( e, lisCausales ) );
    } );
  }

  crearItem( e: any, lisCausal: any[] = [] ) {
    const a = {} as any;
    a.control = e[ this.keys[ this.tipo ].control ];
    a.idControl = e[ this.keys[ this.tipo ].idControl ];
    a.id = e[ this.keys[ this.tipo ].id ];
    this.cargarCausal( a, lisCausal );
    a.estado = e.estado;
    a.idEstado = e.idEstado;
    a.idFlujoVentaPaso = e.idFlujoVentaPaso;
    a.cantidadReintentos = e.cantidadReintentos;
    a.indicadorHabilitado = e.indicadorHabilitado;
    a.indicadorMostrarObservacion = e.indicadorMostrarObservacion;
    a.indicadorAplicaReintentos = e.indicadorAplicaReintentos;
    a.objeto = e;
    return a;
  }

  cargarCausal( a: any, lisCausales: any[] ) {
    a.lisCausales = [];
    a.causal = '';
    a.causalHabilitado = [];
    lisCausales.forEach( e => {
      if ( e[ this.keys[ this.tipo ].id ] === a.id ) {
        a.lisCausales.push( e );
        if ( e.indicadorHabilitado ) {
          a.causal += e.causalSolicitud + ',';
          a.causalHabilitado.push( e.idCausalSolicitud );
        }
      }
    } );
    if ( a.causal.length > 0 ) {
      a.causal = a.causal.substring( 0, a.causal.length - 1 );
    }
  }

  cargarItems() {
    this.lisControles = [];
    this.lisItemTodos.forEach( e => {
      if ( !this.listado.find( x => x.idControl === e.value && ( !this.regSeleccionado || this.regSeleccionado.id !== x.id ) ) ) {
        this.lisControles.push( e );
      }
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idPrincipal: [ this.regSeleccionado ? this.regSeleccionado.id : null ],
      idFlujoVentaPaso: [ this.regSeleccionado ? this.regSeleccionado.idFlujoVentaPaso : this.fluVentaPaso.idFlujoVentaPaso, [ Validators.required ] ],
      idControl: [ this.regSeleccionado ? this.regSeleccionado.idControl : null, [ Validators.required ] ],
      idEstado: [ this.regSeleccionado ? this.regSeleccionado.idEstado : null, [ Validators.required ] ],
      cantidadReintentos: [ this.regSeleccionado ? this.regSeleccionado.cantidadReintentos : null, ( this.regSeleccionado && this.regSeleccionado.indicadorAplicaReintentos ) ? [ Validators.required ] : [] ],
      idCausales: [ this.regSeleccionado ? this.regSeleccionado.causalHabilitado : [], [ Validators.required ] ],
      indicadorMostrarObservacion: [ this.regSeleccionado ? this.regSeleccionado.indicadorMostrarObservacion : false ],
      indicadorAplicaReintentos: [ this.regSeleccionado ? this.regSeleccionado.indicadorAplicaReintentos : false ],
      indicadorHabilitado: [ this.regSeleccionado ? this.regSeleccionado.indicadorHabilitado : true ],
    } );

    if ( this.regSeleccionado ) {
      this.cargarCausales( this.regSeleccionado.idEstado, false );
    }

  }

  cambioIntento( cambioCheck: boolean ) {
    this.f.cantidadReintentos.setValidators( cambioCheck ? [ Validators.required ] : [] );
    this.f.cantidadReintentos.setValue( null );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }
    this.cargando = true;
    const registro = this.formulario.value;
    registro[ this.keys[ this.tipo ].id ] = registro.idPrincipal;
    registro[ this.keys[ this.tipo ].idControl ] = registro.idControl;
    registro.cantidadReintentos = registro.indicadorAplicaReintentos ? registro.cantidadReintentos : 0;
    if ( registro.idPrincipal ) {
      this[ this.keys[ this.tipo ].servicio ].actualizar( registro ).subscribe( async a => {
        this.finalizarGuardado( registro, 2, await this.validarCausales( registro ) );
      } );
    } else {
      this[ this.keys[ this.tipo ].servicio ].crear( registro ).subscribe( async c => {
        registro[ this.keys[ this.tipo ].id ] = c[ this.keys[ this.tipo ].id ];
        this.finalizarGuardado( registro, 1, await this.validarCausales( registro ) );
      } );
    }

  }

  async validarCausales( registro: any ) {
    const registros = [];
    const lisCausales = this.regSeleccionado ? this.regSeleccionado.lisCausales : [];

    registro.idCausales.forEach( e => {
      const existe = lisCausales.find( x => x.idCausalSolicitud === e );
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        registros.push( existe );
      } else if ( !existe ) {
        const nueRegistro = {} as any;
        nueRegistro.idCausalSolicitud = e;
        nueRegistro.indicadorHabilitado = true;
        nueRegistro[ this.keys[ this.tipo ].id ] = registro[ this.keys[ this.tipo ].id ];
        const causal = this.lisCausales.find( x => x.value === e );
        if ( causal ) {
          nueRegistro.causalSolicitud = causal.label;
        }
        registros.push( nueRegistro );
      }
    } );

    lisCausales.forEach( e => {
      if ( !registro.idCausales.find( y => y === e.idCausalSolicitud ) && e.indicadorHabilitado ) {
        e.indicadorHabilitado = false;
        registros.push( e );
      }
    } );

    if ( registros.length > 0 ) {
      const regCreados = await this[ this.keys[ this.tipo ].servicioCausal ].bulk( registros ).toPromise();
      registros.forEach( e => {
        if ( !e[ this.keys[ this.tipo ].idCausal ] ) {
          const regBuscar = regCreados.find( x => x.idCausalSolicitud === e.idCausalSolicitud );
          if ( regBuscar ) {
            e[ this.keys[ this.tipo ].idCausal ] = regBuscar[ this.keys[ this.tipo ].idCausal ];
            lisCausales.push( e );
          }
        }
      } );
    }
    return lisCausales;
  }


  finalizarGuardado( registro: any, tipo: number, lisCausales: any[] ) {
    const control = this.lisControles.find( x => x.value === registro.idControl );
    registro[ this.keys[ this.tipo ].control ] = control ? control.label : null;
    const estado = this.lisEstados.find( x => x.value === registro.idEstado );
    registro.estado = estado ? estado.label : null;
    if ( tipo === 1 ) {
      this.listado.push( this.crearItem( registro, lisCausales ) );
    } else {
      const itemIndex = this.listado.findIndex( x => x.id === registro[ this.keys[ this.tipo ].id ] );
      if ( itemIndex >= 0 ) {
        this.listado[ itemIndex ] = this.crearItem( registro, lisCausales );
      }
    }
    this.reiniciarForm();
    this.navService.setMesage( tipo );
    this.cargando = false;
  }

  editar( registro: any ) {
    this.regSeleccionado = registro;
    this.reiniciarForm( false );
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `flujoVentaReintento${ this.fluVentaPaso.codigo }`,
        accept: () => {
          this.reiniciarForm();
        },
        reject: () => {
        }
      } );
    } else {
      this.reiniciarForm();
    }
  }

  get f() {
    return this.formulario.controls;
  }

  reiniciarForm( setSeleccionado: boolean = true ) {
    this.lisCausales = [];
    if ( setSeleccionado ) {
      this.regSeleccionado = null;
    }
    this.submitted = false;
    this.cargarFormulario();
    this.formulario.markAsPristine();
    this.cargarItems();
  }

  async cargarCausales( idEstado: string, reiniciar: boolean = true ) {
    this.carEstados = true;
    this.lisCausales = [];
    const listado = await this.estCausalService.listadoPorEstadoHabilitado( idEstado ).toPromise();
    listado.forEach( e => {
      this.lisCausales.push( { label: e.causalSolicitud, value: e.idCausalSolicitud } );
    } );

    if ( reiniciar ) {
      this.f.idCausales.setValue( [] );
    } else {
      const causales = [];
      this.f.idCausales.value.forEach( e => {
        if ( !!this.lisCausales.find( y => y.value === e ) ) {
          causales.push( e );
        }
      } );
      this.f.idCausales.setValue( causales );
    }

    if ( this.lisCausales.length === 0 ) {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'FLUJOVENTAREINTENTO.MSG_NOEXISTENCAUSALES' )
      } );
    }

    this.carEstados = false;
  }

  salir() {
    this.dismiss.emit( true );
  }


}
